import EditIcon from "@mui/icons-material/Edit";
import { IconButton, useMediaQuery } from "@mui/material";
import React from "react";

import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { ModalComponent } from "../../../../../ui-components/Modal";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { updateCommission } from "../../../../../services/commissions.service";
import {
  adminButtonOutlinedSx,
  adminButtonPrimarySx,
} from "../../../modalStyle";
import { useToast } from "../../../../../ui-components/ToastProvider";

// Modal e botões seguem o padrão do dashboard via adminModalSx/adminButton* Sx

interface Commission {
  id: number;
  user_id: number;
  subscription_id: number;
  amount: number;
  is_paid: any;
  created_at: Date;
}

export default function UpdateButton({
  id,
  updateCommisions,
  sub,
}: {
  id: number;
  updateCommisions: Function;
  sub: Commission;
}) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { showToast } = useToast();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const formData: any = Object.fromEntries(new FormData(e.target).entries());
    console.log(formData);
    formData.is_paid = Boolean(+formData.is_paid);
    console.log(formData);

    updateCommission(formData, id).then(() => {
      showToast("Comissão alterada com sucesso!", { severity: "success" });
      updateCommisions();
    });
    handleClose();
  };

  return (
    <>
      <ModalComponent open={open} handleClose={handleClose} title="Editando as informações da Comissão">
        <form onSubmit={handleSubmit}>
          <Box sx={{ p: 3 }}>
            <FormControl fullWidth size="small">
              <InputLabel id="is-paid-label">Pagamento Efetuado</InputLabel>
              <Select
                labelId="is-paid-label"
                name="is_paid"
                label="Pagamento Efetuado"
                defaultValue={+sub.is_paid}
              >
                <MenuItem value={+true}>Sim</MenuItem>
                <MenuItem value={+false}>Não</MenuItem>
              </Select>
            </FormControl>
            <Box
              sx={{
                mt: 3,
                borderTop: "1px solid",
                borderColor: "divider",
                display: "flex",
                flexDirection: isMobile ? "column" : "row-reverse",
                justifyContent: isMobile ? "flex-end" : "flex-start",
                gap: 2,
                pt: 1,
              }}
            >
              <Button
                type="submit"
                variant="contained"
                sx={adminButtonPrimarySx}
              >
                Alterar
              </Button>
              <Button
                onClick={handleClose}
                variant="outlined"
                sx={adminButtonOutlinedSx}
              >
                Cancelar
              </Button>
            </Box>
          </Box>
        </form>
      </ModalComponent>
      <IconButton
        onClick={() => {
          handleOpen();
          updateCommisions();
        }}
      >
        <EditIcon />
      </IconButton>
    </>
  );
}
